import { COOKIE_SERVICE as f, PhoneFormat as h } from "@packages/common";
import { CONFIG as g } from "@packages/config";
import { Injectable as b, Inject as s } from "@webmotors/ioc";
import { LEAD_FORM_DATA_SERVICE as D } from "./main31.js";
var _ = Object.getOwnPropertyDescriptor, N = (o, t, e, r) => {
  for (var m = r > 1 ? void 0 : r ? _(t, e) : t, a = o.length - 1, n; a >= 0; a--)
    (n = o[a]) && (m = n(m) || m);
  return m;
}, u = (o, t) => (e, r) => t(e, r, o);
let l = class {
  /**
   * Initializes a new instance of the `LeadFormDataService` class.
   * @param cookie - The cookie service for managing encrypted cookie data.
   * @param config - The application configuration containing cookie-related settings.
   */
  constructor(o, t) {
    this.cookie = o, this.config = t;
  }
  /**
   * Retrieves and decrypts lead form data from cookies.
   *
   * @returns An object containing lead form data with default values if no data is found.
   */
  get() {
    const o = this.cookie.getDecrypted(
      this.config.formDataCookieName
    ), t = this.getDefaultFormData();
    if (!(o != null && o.Principal))
      return t;
    const { Principal: e } = o;
    return {
      email: (e == null ? void 0 : e.email) ?? t.email,
      name: (e == null ? void 0 : e.fullName) ?? t.name,
      message: (e == null ? void 0 : e.message) ?? t.message,
      newsletter: (e == null ? void 0 : e.newsletter) ?? t.newsletter,
      phoneNumber: (e == null ? void 0 : e.numberPhone) ?? t.phoneNumber,
      formattedPhoneNumber: e != null && e.numberPhone ? h.clean(e.numberPhone) : t.formattedPhoneNumber
    };
  }
  /**
   * Provides default values for `FormData` when no data is found in cookies.
   *
   * @returns The default `FormData` object.
   */
  getDefaultFormData() {
    return {
      email: null,
      name: null,
      message: null,
      newsletter: !1,
      phoneNumber: null,
      formattedPhoneNumber: null
    };
  }
};
l = N([
  b(D),
  u(0, s(f)),
  u(1, s(g))
], l);
export {
  l as LeadFormDataService
};
